// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPickerPopupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Color Picker component
 */
!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withState = require('recompose').withState;
  var onlyUpdateForPropTypes = require('recompose').onlyUpdateForPropTypes;
  var setPropTypes = require('recompose').setPropTypes;
  const { curry } = require('lodash/fp');
  var ColorPickerPopupAction = compose(
    withState('selectedColor', 'setColor', function(props) {
      return props.color;
    }),
    withHandlers({
      handleOnChange: curry(function(props, color) {
        props.setColor(color.hex);
      }),
      handleAccept: function(props) {
        return function() {
          props.onAcceptColor(props.selectedColor);
          props.onAccept();
        };
      },
      hideColorPicker: function(props) {
        return props.onReject;
      }
    }),
    onlyUpdateForPropTypes,
    setPropTypes({
      onAcceptColor: React.PropTypes.func.isRequired,
      onAccept: React.PropTypes.func.isRequired,
      onReject: React.PropTypes.func.isRequired,
      color: React.PropTypes.string
    })
  );

  module.exports = ColorPickerPopupAction;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ColorPickerPopupAction.js